import React, { useEffect } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import {
  Button,
  Menu,
  MenuList,
  Popper,
  ClickAwayListener,
  Paper,
} from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

interface Menu {
  href: string;
  title: string;
  disabled: boolean;
}

interface ISubMenuProps {
  title: string;
  items: Menu[];
  visible?: boolean;
  anchor: null | HTMLElement;
  drawerOpen: boolean;
}

const NavSubMenu: React.FC<ISubMenuProps> = ({
  title,
  items,
  anchor,
  drawerOpen,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  useEffect(() => {
    setAnchorEl(anchor);
  }, [anchor]);

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const translatedTitle: any = title;

  return (
    <Popper
      id="submenu"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      transition
      placement="right-start"
      className={classes.container}
      onMouseLeave={handleClose}
    >
      <div className={classes.blank}>
        {!drawerOpen && (
          <span className={classes.title}>{t(translatedTitle)}</span>
        )}
      </div>
      <Paper className={classes.paper}>
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList className={classes.menu} autoFocusItem={Boolean(anchorEl)}>
            {items.map((item, index) => {
              const translatedItemTitle: any = item.title;
              return (
                <div key={item.title}>
                  <Button
                    disabled={item.disabled}
                    activeClassName={classes.active}
                    className={clsx(classes.button, {
                      [classes.lastItem]: index === items.length - 1,
                    })}
                    classes={{ disabled: classes.inactive }}
                    component={RouterLink}
                    to={item.href}
                    disableFocusRipple
                    disableTouchRipple
                    disableRipple
                    focusRipple={false}
                    onClick={() => setAnchorEl(null)}
                  >
                    {t(translatedItemTitle)}
                  </Button>
                </div>
              );
            })}
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popper>
  );
};

export default NavSubMenu;
